import {
    apiRequest,
    laporanPenilaianSKPCreate, 
    laporanPenilaianSKPUpdate
} from "../../../../../services/adapters/kepegawaian/laporanPenilaianSKPService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", laporanPenilaianSKPCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", laporanPenilaianSKPUpdate, {
            body: query
        }, true)
    }

}

export default CreateRepository